import React, { useState } from "react";
import Styles from "../../ConGenMain.module.css";
import AvailableHeader from "../../HeadingElements/AvailableHeader";
import AvailableListing from "./AvailableListing";

const AvailableListingContainer = ({ showBackbtn = false }) => {
  const [energyRateSortDir, setEnergyRateSortDir] = React.useState("");
  const [quantitySortDir, setQuantitySortDir] = React.useState("");
  const [activeFilter, setActiveFilter] = useState("ALL");
  const [listingCount, setListingCount] = useState(0);
  const [filterState, setFilterState] = useState({
    quantity: [0, 10000],
    energyRate: [0, 200],
    creditRating: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });

  return (
    <div>
      <div className={Styles.elemHeaderAvailable}>
        <AvailableHeader
          showBackbtn={showBackbtn}
          setFilterState={setFilterState}
          filterState={filterState}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          energyRateSortDir={energyRateSortDir}
          quantitySortDir={quantitySortDir}
          setEnergyRateSortDir={setEnergyRateSortDir}
          setQuantitySortDir={setQuantitySortDir}
          stateListingCount={listingCount}
        />
      </div>
      <div
        className={`scroll_bar_x scroll_bar_y ${Styles.availableListingContainer}`}
      >
        <AvailableListing
          showBackbtn={showBackbtn}
          filterState={filterState}
          energyRateSortDir={energyRateSortDir}
          quantitySortDir={quantitySortDir}
          setEnergyRateSortDir={setEnergyRateSortDir}
          setQuantitySortDir={setQuantitySortDir}
          activeFilter={activeFilter}
          setListingCount={setListingCount}
        />
      </div>
    </div>
  );
};

export default AvailableListingContainer;
